import { Attributes, DateUtils, Misc, Model, Rules, Validation } from '@singularsystems/neo-core';

export default class ShareAllocationListCriteria extends Model.CriteriaBase {
    static typeName = "ShareAllocationListCriteria";

    constructor() {
        super();
        this.makeObservable();
    }

    @Rules.Required()
    @Attributes.Date(Misc.TimeZoneFormat.None)
    public effectiveDate: Date | null = DateUtils.today();

    @Attributes.Nullable()
    public issuerInvestmentId: number | null = null;

    // Client only properties / methods

    @Attributes.NoTracking()
    public issuerInvestmentName: string = "";

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Share Allocation List Criteria";
    }
}